import { getValue, setValue } from './key-value-store';

export const getMmsTopScore = async (mmsId: string): Promise<number> => {
  const mmsIdRefTopScore = `${mmsId}-feedback-top-score`;
  const scoreRecorded = await getValue(mmsIdRefTopScore);
  const highestScore = scoreRecorded?.[mmsIdRefTopScore] || 0;
  return highestScore;
};

export const setMmsTopScore = async (mmsId: string, score: number): Promise<void> => {
  const mmsIdRefTopScore = `${mmsId}-feedback-top-score`;
  await setValue({ [mmsIdRefTopScore]: `${score}` });
};
